const heading = {
	group: "block",
	content: "inline*",
	defining: true,
	attrs: {
		level: { default: 1 },
		id: { default: null },
		isCustomId: { default: false },
	},
};

export default heading;
